/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParkingItemApiFrom } from '../../models/parking-item-api-from';

export interface ApiV3ServiceListParkingGet$Params {

/**
 * Interface language
 */
  lang?: string;
}

export function apiV3ServiceListParkingGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceListParkingGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ParkingItemApiFrom>>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceListParkingGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ParkingItemApiFrom>>;
    })
  );
}

apiV3ServiceListParkingGet.PATH = '/api/v3/service/ListParking';
